import { OVERFLOW_SIDE } from './constants';
import { OverflowSide } from './types';
import { PlacementStyles } from './calculatePlacementAndStyles';

type OverflowSides = OverflowSide[];

const getOverflowSides = (
  contentWidth: number,
  contentHeight: number,
  pagePadding: number,
  placementStyles: PlacementStyles
): OverflowSides => {
  const overflowSides: OverflowSides = [];

  const topSpace = placementStyles.top - window.scrollY;
  const bottomSpace = window.scrollY + window.innerHeight - placementStyles.top;

  // если закрыто 20 и более процентов контента, то оно переносится наверх
  if (topSpace > bottomSpace && bottomSpace / contentHeight <= 0.8) {
    overflowSides.push(OVERFLOW_SIDE.BOTTOM);
  }

  if (placementStyles.left < pagePadding) {
    overflowSides.push(OVERFLOW_SIDE.LEFT);
  }

  if (placementStyles.left + contentWidth > window.innerWidth - pagePadding) {
    overflowSides.push(OVERFLOW_SIDE.RIGHT);
  }

  if (overflowSides.length) {
    return overflowSides;
  }

  return [];
};

export default getOverflowSides;
